import { useEffect } from 'react'
import { useAuth } from '../../context/AuthContext'
import { logoutUrl } from '../../hooks/useAccount'

export const redirectToLogout = () => {
    window.location.replace(logoutUrl)
}

const LogoutRedirectPage = () => {
    var auth = useAuth()
    auth?.logout()

    useEffect(() => {
        redirectToLogout()
    }, []);

    return <></>
}

export default LogoutRedirectPage